import * as React from 'react';
import _ from 'lodash';

const debug = require('../debug/debug')('wc:video:TimelineNode');
let _i = 0;

type Props = {
  data: Object,
  y: number,
  type: string,
  color: string,
  pps: number,
  isExpanded: boolean,
  onClick: Function,
  onMouseEnter: Function,
  onMouseLeave: Function,
  onMouseDown: Function
};

export default class TimelineNode extends React.PureComponent<Props> {
  onMouseDown = (e: MouseEvent, data: object) => {
    const { onMouseDown } = this.props;
    onMouseDown(e, data);
    this.addMouseListeners();
  };

  addMouseListeners = () => {
    document.addEventListener('mousemove', this.mouseMove);
    document.addEventListener('mouseup', this.mouseUp);
  };

  removeMouseListeners = () => {
    document.removeEventListener('mousemove', this.mouseMove);
    document.removeEventListener('mouseup', this.mouseUp);
  };
  mouseMove = (e: MouseEvent) => {
    const { data, mouseMove } = this.props;
    mouseMove(e, data);
  };

  mouseUp = (e: MouseEvent) => {
    const { data, type, mouseUp } = this.props;
    mouseUp(e, type, data);
    this.removeMouseListeners();
  };

  render() {
    // debug(`[render ${++_i}] props: `, this.props);

    const { data, y = 17, type, color, pps, onMouseEnter, onMouseLeave, onClick, onMouseMove } = this.props;
    const { startTimeMs, stopTimeMs } = data;
    const x1 = startTimeMs > -1 ? (startTimeMs / 1000) * pps : (stopTimeMs / 1000) * pps;
    const x2 = stopTimeMs > -1 ? (stopTimeMs / 1000) * pps : (startTimeMs / 1000) * pps;

    return (
      <g name="TimelineNode" className="TimelineNode">
        <line
          x1={x1}
          x2={x2}
          y1={y}
          y2={y}
          id={data._id}
          data-nodeid={data._cid}
          nodeid={data.id}
          data-color={color.replace('#', '')}
          strokeWidth="14px"
          strokeLinecap=""
        />
        <rect
          style={{ height: '14px' }}
          x={x1 - 3}
          y={y - 7}
          _id={data._id}
          width={Math.abs(x2 - x1 + 6) > 2 ? Math.abs(x2 - x1 + 6) : 2}
          height={24}
          stroke="#0000"
          fill="#0000"
          tabIndex={data._cid}
          className="timeline-node"
          onClick={(e: MouseEvent) => onClick(e, type, data)}
          //onFocus={ (e: FocusEvent) => onClick(e, type, data)}
          onMouseEnter={(e: MouseEvent) => onMouseEnter(e, type, data)}
          onMouseLeave={(e: MouseEvent) => onMouseLeave(e, type, data)}
          onMouseMove={(e: MouseEvent) => onMouseMove(e, type, data)}
          onMouseDown={(e: MouseEvent) => this.onMouseDown(e, data)}
        />
      </g>
    );
  }
}

type Word = {
  word: string,
  confidence: number
};

type TranscriptionData = {
  id: number,
  startTimeMs: number,
  stopTimeMs: number,
  words: Word[]
};

type TranscriptionProps = {
  ...Props,
  data: TranscriptionData
};

export class TimelineTranscriptionNode extends React.PureComponent<TranscriptionProps> {
  render() {
    // debug(`[render ${++_i}] props: `, this.props);
    const { data, i, y = 17, type, color, pps, onClick, onMouseEnter, onMouseLeave } = this.props;
    const { startTimeMs, stopTimeMs, words } = data;
    let nodes;
    if (words) {
      nodes = words.map((word: Word, j: number) => {
        const x1 = (startTimeMs / 1000) * pps;
        const x2 = (stopTimeMs / 1000) * pps;

        return (
          <g key={`row_${i}_cell_${j}`}>
            <line
              x1={x1}
              x2={x2}
              y1={y}
              y2={y}
              data-nodeid={data._cid}
              data-color={color.replace('#', '')}
              // strokeLinecap="round"
            />
            <rect
              x={x1 - 3}
              y={y - 5}
              width={x2 - x1 + 6}
              height={10}
              rx="10"
              ry="5"
              stroke="#0000"
              fill="#0000"
              tabIndex={data._cid}
              className="timeline-node"
              onClick={(e: MouseEvent) => onClick(e, type, data)}
              onFocus={(e: FocusEvent) => onClick(e, type, data)}
              onMouseEnter={(e: MouseEvent) => onMouseEnter(e, type, data)}
              onMouseLeave={(e: MouseEvent) => onMouseLeave(e, type, data)}
            />
          </g>
        );
      });
    } else {
      nodes = [];
    }

    return <g name="TimelineTranscriptionNode">{nodes}</g>;
  }
}
